/**
 * Created by andrey on 03.07.16.
 */

export interface IModel {
  id: string;
  $uid: string;
}

export class Model implements IModel {
  public id: string;
  public $uid: string;

  constructor(id: string = null) {
    if (id) {
      this.id = id;
      this.$uid = id;
    } else {
      this.$uid = Math.random().toString();
    }
  }
}
